<template>
  <div>
    <el-dialog
      title="Шаблоны измерений в картах"
      :visible.sync="show"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="false"
    >
      <template slot="title">
        <div style="display: flex; justify-content: space-between">
          <div>
            Шаблоны измерений в картах
          </div>
          <el-button
            type=""
            size="mini"
            icon="fas fa-plus"
            @click="createScaleTemplate"
          >
            Создать шаблон
          </el-button>
        </div>
      </template>




      <div v-loading="loading">
        <el-card
          v-for="template in templates"
          :key="template.id"
          style="margin-bottom: 10px"
        >
          <CascadingCardScaleEditForm
            :template="template"
            @deleted="loadScaleTemplates"
          ></CascadingCardScaleEditForm>
        </el-card>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show=false">Закрыть</el-button>
      </span>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";
import CascadingCardScaleEditForm from "@/modules/cascading/components/cardScale/CascadingCardScaleEditForm.vue";

export default {
  name: "CascadingCardScaleTemplatesEditModal",
  components: { CascadingCardScaleEditForm },
  props: {},

  data() {
    return {
      loading: false,
      show: false,
      templates: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.show = true;
      this.loadScaleTemplates();
    },

    loadScaleTemplates() {
      this.loading = true;
      this.$api.cascading.getCardScaleTemplates()
        .then(data => {
          this.templates = data.templates;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    createScaleTemplate() {
      this.loading = true;
      this.$api.cascading.createCardScaleTemplate()
        .finally(() => {
          this.loadScaleTemplates();
        })
    },


  },


}
</script>
